import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import { IconClose } from "@ui/icons/IconClose";
import Panel from "@ui/panel/Panel";
import { Rows } from "@ui/table/Rows";
import { Typo } from "@ui/text/Typo";
import Signal from "badmfck-signal";
import { useState } from "react";
import { GD } from "src/GD";

export const S_ADD_FILES_POPUP = new Signal<{
	target_id: number;
	target_type: "client" | "merchant";
	onChange?: () => void;
} | null>("S_ADD_FILES_POPUP");

export const fileInput = document.createElement("input") as HTMLInputElement;
fileInput.type = "file";
fileInput.style.display = "none";
document.body.appendChild(fileInput);

export const AddFilesPopup = () => {
	useLocale();
	const requestData = S_ADD_FILES_POPUP.use();
	const [busy, setBusy] = useState<boolean>();
	const [error, setError] = useState<IError>();

	const [filesToAdd, setFilesToAdd] = useState<File[]>([]);

	const handleSubmit = async () => {
		if (requestData) {
			if (filesToAdd.length === 0) {
				setError({
					code: -1,
					message: msg("noFilesToSubmit"),
				});
				//alert("no files to submit");
				return;
			}
			setBusy(true);

			const resp = await GD.REQ_FILES_SAVE.request({
				target_id: requestData.target_id,
				target_type: requestData.target_type,
				files: filesToAdd,
			});

			if (resp.error) {
				setError(resp.error);
			} else {
				setFilesToAdd([]);

				requestData.onChange && requestData.onChange();
				closePopup();
			}
			setBusy(false);
			//!TODO mark files with error (error.stack)
		}
	};

	const handleFileRemove = (f: File) => {
		const newFiles = filesToAdd.filter(val => val !== f);
		setFilesToAdd(newFiles);
	};

	const handleFileAdd = (_: any) => {
		setError(undefined);
		fileInput.onchange = _ => {
			if (fileInput.files) {
				const files = [];
				for (let i = 0; i < fileInput.files.length; i++) {
					const f = fileInput.files.item(i);
					if (!f) continue;
					if (filesToAdd.findIndex(val => val.name === f.name && val.size === f.size) > -1) continue;

					if (f.size > 99 * 1024 * 1024) continue;

					files.push(f);
				}
				let total = [...filesToAdd, ...files];
				if (total.length > 5) total = total.slice(0, 10);
				setFilesToAdd(total);
			}
			fileInput.value = "";
			fileInput.onchange = null;
			fileInput.oncancel = null;
		};
		fileInput.oncancel = _ => {
			fileInput.value = "";
			fileInput.onchange = null;
			fileInput.oncancel = null;
		};

		fileInput.click();
	};

	if (!requestData) return null;

	const closePopup = () => {
		S_ADD_FILES_POPUP.invoke(null);
		setError(undefined);
		setFilesToAdd([]);
	};

	const humanFileSize = (bytes: number, si = false, dp = 1) => {
		const thresh = si ? 1000 : 1024;

		if (Math.abs(bytes) < thresh) {
			return bytes + " B";
		}

		const units = si ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
		let u = -1;
		const r = 10 ** dp;

		do {
			bytes /= thresh;
			++u;
		} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

		return bytes.toFixed(dp) + " " + units[u];
	};

	return (
		<Panel
			sx={{
				width: "500px",
				maxWidth: "1200px",
				height: "80vh",
				padding: "0",
				minWidth: "500px",
			}}
			decorator="absolute"
			busy={busy}
			label={msg("addFiles")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					padding: "40px 20px",
					backgroundColor: "#EEF0F2",
				}}>
				<Rows
					data={
						filesToAdd.map(f => {
							return {
								name: f.name,
								size: f.size,
								close: "close",
								file: f,
							};
						}) ?? []
					}
					bulk={false}
					order={["name", "size", "close"]}
					cellFactory={(_row, cell, _index, _key, _name, _sx, _expanded, _rowID) => {
						if (_name === "name") {
							return {
								content: <Typo variant="text">{cell}</Typo>,
							};
						}
						if (_name === "close") {
							return {
								content: (
									<Button
										icon={<IconClose />}
										sx={
											{
												// position: "absolute",
												// top: "10px",
												// right: "10px",
											}
										}
										onClick={() => handleFileRemove(_row.file)}
									/>
								),
							};
						}

						if (_name === "size") {
							return {
								content: <Typo variant="text">{humanFileSize(_row.size, true)}</Typo>,
							};
						}

						return { content: cell };
					}}
				/>

				{/* {filesToAdd &&
				filesToAdd.length &&
				filesToAdd.map((val: File, index: number) => {
					return (
						<HBox key={index}>
							{val.name}{" "}
							<Button
								title="x"
								onClick={() => handleFileRemove(val)}
							/>
						</HBox>
					);
				})} */}
			</VBox>

			<VBox sx={{ padding: "20px", gap: "12px" }}>
				<Error error={error} />

				<HBox gap="10px">
					<Button title={msg("addFile")} onClick={handleFileAdd} />
					<Button
						title={msg("submit_155f816c")}
						onClick={() => {
							handleSubmit();
						}}
					/>
				</HBox>
			</VBox>
		</Panel>
	);
};
